import Api from "@/service/Api";

const api = () => Api();

export default {
  options: () => api().get("/tenant/options"),
  switchTo: (slug) => api().post("/tenant/switch", { slug }),
  listAll: () => api().get("/platform/tenants"),
  create: (data) => api().post("/platform/tenants", data),
  update: (id, data) => api().put(`/platform/tenants/${id}`, data),
  activation: (id, active) => api().patch(`/platform/tenants/${id}/activation`, { active }),
  addDomain: (id, data) => api().post(`/platform/tenants/${id}/domains`, data),
  makePrimaryDomain: (id, domainId) => api().patch(`/platform/tenants/${id}/domains/${domainId}/primary`),
  removeDomain: (id, domainId) => api().delete(`/platform/tenants/${id}/domains/${domainId}`),
};
